import { SetStateAction, useState, useEffect } from 'react'
import { useDebounce } from 'use-debounce';
import { MultiSelectChangeEvent, MultiSelectAllEvent } from 'primereact/multiselect';
import { ClientList, KamList } from 'types/authorization';
import { UseGetClients, UseGetKams } from 'request'
import { catalogQuery } from 'request/catalogs';




export interface InputProps {
  username: string
  name: string
}

type subMenuAuthorizator = 'pending' | 'approved' | 'default' | 'rejected'

interface Props {
  setFilterData?: SetStateAction<any>
  filterData?: any
  userSelectData: subMenuAuthorizator
}


export enum SelectName {
  KAM = 'kam',
  CLIENT = 'client'
}

export const useFiltersAuthorization = ({ filterData, setFilterData, userSelectData }: Props) => {

  const [input, setInput] = useState<InputProps>({
    username: '',
    name: ''
  })

  const clearInputs = () => {
    setInput({
      username: '',
      name: ''
    })
  }




  const [debouncedKamsInput] = useDebounce(input.username, 500);
  const [debouncedClientInput] = useDebounce(input.name, 500);


  const {data: dataAuthorizatorApproved, isLoading: isLoadingDataAuthorizatorApprove } = catalogQuery.useGetKamsApproved({ username: debouncedKamsInput, view: userSelectData })
  const {data: dataAuthorizatorRejected, isLoading: isLoadingDataAuthorizatorRejected } = catalogQuery.useGetKamsRejected({ username: debouncedKamsInput, view: userSelectData })
  const {data: dataAuthorizatorPending, isLoading: isLoadingDataAuthorizatorPending } = catalogQuery.useGetKamsPending({ username: debouncedKamsInput, view: userSelectData })


  const { data: dataClients, isLoading: isLoadingDataClients } = UseGetClients({ name: debouncedClientInput })

  const kamsSelect = 
    userSelectData === 'pending' && dataAuthorizatorPending ?   
    [
      ...dataAuthorizatorPending?.data.map((item: KamList) => (
        { label: item.name, value: item.id }
      ))
    ] : userSelectData === 'approved' && dataAuthorizatorApproved ?
    [
      ...dataAuthorizatorApproved?.data.map((item: KamList) => (
        { label: item.name, value: item.id }
      ))
    ] : userSelectData === 'rejected' && dataAuthorizatorRejected ?
    [
      ...dataAuthorizatorRejected?.data.map((item: KamList) => (
        { label: item.name, value: item.id }
      ))
    ] : []

  const clientsSelect = dataClients &&
    [
      ...dataClients.data.map((item: ClientList) => (
        { label: item.name, value: item.id }
      ))
    ]


  const [selectAllKam, setSelectAllKam] = useState(false)
  const [selectAllClient, setSelectAllClient] = useState(false)
  const [multiSelectKam, setMultiSelectKam] = useState<string[] | undefined>([])
  const [multiSelectClient, setMultiSelectClient] = useState<string[] | undefined>([])

  const username = multiSelectKam
  const serviceClient = multiSelectClient


  useEffect(() => {

    if (clientsSelect && multiSelectClient && clientsSelect.length == multiSelectClient.length) {

      setFilterData({
        ...filterData,
        username,
        serviceClient
      })
    }


    setFilterData({
      ...filterData,
      username,
      serviceClient
    })

  }, [multiSelectClient])

  useEffect(() => {

    if (kamsSelect && multiSelectKam && kamsSelect.length == multiSelectKam.length) {

      setFilterData({
        ...filterData,
        username,
        serviceClient
      })
    }


    setFilterData({
      ...filterData,
      username,
      serviceClient
    })
  }, [multiSelectKam])






  const cleanSelectKamAndClient = () => {
    setSelectAllKam(false)
    setSelectAllClient(false)
    setMultiSelectKam([])
    setMultiSelectClient([])
  }



  const handleMultiSelect = (event: MultiSelectChangeEvent, id: SelectName) => {

    if (id === SelectName.KAM) {
      setMultiSelectKam(event.value)
      setSelectAllKam(event.value.length === kamsSelect?.length)

    }
    if (id === SelectName.CLIENT) {
      setMultiSelectClient(event.value)
      setSelectAllClient(event.value.length === clientsSelect?.length)
    }

  }


  const onSelectAll = (e: MultiSelectAllEvent, id: SelectName) => {

    if (id === SelectName.KAM) {
      setMultiSelectKam(e.checked ? [] : kamsSelect?.map((item) => item.value))
      setSelectAllKam(!e.checked)
    }

    if (id === SelectName.CLIENT) {
      setMultiSelectClient(e.checked ? [] : clientsSelect?.map((item) => item.value))
      setSelectAllClient(!e.checked)

    }

  }





  return {
    kamsSelect,
    clientsSelect,
    input,
    isLoadingDataAuthorizator: isLoadingDataAuthorizatorPending || isLoadingDataAuthorizatorApprove || isLoadingDataAuthorizatorRejected,
    isLoadingDataClients,
    clearInputs,
    handleMultiSelect,
    multiSelectKam,
    multiSelectClient,
    cleanSelectKamAndClient,
    username,
    serviceClient,
    selectAllKam,
    selectAllClient,
    setMultiSelectKam,
    setMultiSelectClient,
    setSelectAllKam,
    setSelectAllClient,
    onSelectAll,
  }

}
